<template>
	<div class="text">
		<p class="head">⼀、前⾔</p>
		<p>感谢您使用芝麻招工！为打造⼀个合法、安全、公平、真实、准确、效率的招聘求职信息服务平台，我们对芝麻招工招工信息发布制定了基本的规则。</p>
		<p>本《芝麻招工招工信息发布规则》（以下简称“规则”）系您（指个⼈或组织）与上海博夫教育科技有限公司（以下简称“芝麻招工”或“本平台”）订立的《芝麻招工用户服务协议》的有效组成部分，与《芝麻招工用户服务协议》共同构成您与上海博夫教育科技有限公司合作的法律⽂件。
		</p>
		<p>您在使⽤“芝麻招工”填写并发布招工信息之前，请务必审慎阅读、充分理解本规则。您使⽤“芝麻招工”招工信息发布服务的⾏为，即表示您已阅读并同意本规则所涉全部内容。</p>
		<p>“芝麻招工”有权根据法律法规、政策及产品需求更新本规则，请您定期访问并查看最新规则。如您继续使⽤“芝麻招工”平台产品或服务，即表示您接受经修订后的规则。</p>
		<p class="head">⼆、招工信息发布规则</p>
		<p>您应当确保填写的招工相关信息合法、真实、准确，您发布的所有⽂字、图⽚、视频等内容，都不得含有任何违法、政治敏感、不符合公序良俗、侵犯他⼈权益的内容。</p>
		<p>在您填写或修改已有的招工相关信息时，应当遵守的具体规则包括但不限于：</p>
		<p>1. 不得使用“芝麻招工”发送或储存任何违反适用法律或法规的资料；</p>
		<p>2. 不得以任何形式侵犯他人的版权、商标权、商业秘密或其他知识产权；</p>
		<p>3. 不得侵犯个人和社会大众的隐私安全，禁止传输任何非法的、骚扰性的、中伤性的、辱骂性的、恐吓性的、伤害性的、庸俗或淫秽的信息；</p>
		<p>4. 不得发布任何与本平台找活、招工目的不适之信息；</p>
		<p>5. 不得发布任何不完整、不准确、虚假的或具有误导性的信息；</p>
		<p>6. 在招工信息详情中，不得上传和填写与招工⽆关的图⽚或涉及联系⽅式的内容；</p>
		<p>7. 招工信息详情的⽂字内容应当真实、准确、完整，便于求职者理解，不得发布与招工信息详情⽆关的⽂字内容；</p>
		<p>8. 发布的信息中不得包含任何其他个⼈的隐私信息、其他公司的商业信息或党、政、军等涉密信息；</p>
		<p>9. 发布的信息不是出于用人者自身招聘员工、雇佣劳工或人力资源服务等业务目的的；</p>
		<p>10. 用户应当对所编辑、上传、发布内容的真实性、准确性、合法性、有效性、完整性及不侵犯第三方合法权益等独立承担责任。</p>
		<p class="head">三、禁⽌发布的招工信息</p>
		<p>基于合法性、安全性、真实性、有效性等原则考虑，⽬前芝麻招工不提供包含但不限于以下信息的招工发布服务，若您发布的招工信息包含以下内容，可能将随时被驳回（部分或全部屏蔽、删除），对于造成严重后果者，会对涉事账号进行暂时或永久冻结：
		</p>
		<p>违法及不良类信息</p>
		<p>1. 包含违法、政治敏感内容；</p>
		<p>2. 包含⾊情、淫秽、性暗示或三俗内容，如寻找伴侣、寻求包养等；</p>
		<p>3. 包含违反《宪法》、《劳动合同法》等相关法律法规规定的内容等；</p>
		<p>4. 包含对性别、少数民族、乙肝病毒携带者、地域、新冠肺炎康复者等指向性的就业歧视内容；</p>
		<p>5. 包含⼈身攻击或其他侵害他⼈权益的内容；</p>
		<p>虚假/不明确的信息</p>
		<p>6. 包含不真实的招工信息；</p>
		<p>7. 包含虚假的招工者身份信息；</p>
		<p>8. 包含不真实的职位描述、⼯作内容、薪资或⼯作地点等信息；</p>
		<p>9. 招工信息工种类型与招工信息描述或与实际工作内容不符的；</p>
		<p>10. 招工信息标题与招工信息描述不明确的；</p>
		<p>11. 通过注册或使用多个账号等方式重复或刷屏相同招工信息的；</p>
		<p>12. 包含⼴告、寻求合作、传销、直销等内容的；</p>
		<p>13. 包含微信号、QQ号、⼿机号等第三⽅社交账号(或链接)内容的；</p>
		<p>14. 包含鸡汤、段⼦、⽔贴等与招工⽆关的；</p>
		<p>违规或⾼⻛险类信息</p>
		<p>15. 兼职模特、试⾐模特类、涉黄倾向的模特类信息；</p>
		<p>16. ⽆经验交易员、分析师类信息；</p>
		<p>17. 涉及套路贷类招工信息；</p>
		<p>18. 涉及诱导买车、“拉人头”类招工信息；</p>
		<p>19. 涉及剧组、演员、练习⽣、歌⼿类招工信息；</p>
		<p>20. 按摩技师、夜场服务等娱乐类招工信息；</p>
		<p>21. 涉及出海类的职位，如船员、出海捕捞岗位等；</p>
		<p>22. ⼯作地点不在中华人民共和国境内；</p>
		<p>23. 涉及异地培训/实习/代办职业技能证书类的、有关特许经营/传销/俱乐部会员/分销或销售代理信息等的职位；</p>
		<p>24. 信⽤卡套现类职位；</p>
		<p>25. 淘宝刷单、微商代理、⼿机兼职、⼿⼯兼职、代办银行卡、代办手机卡、代开工商信息、代开发票、游戏代练类等职位；</p>
		<p>26. 涉及发布代孕、捐精、捐卵、献血、试药业务等职位；</p>
		<p>27. 涉及恶意招聘⼤量（3个以上）兼职主播类信息，内容涉及陪玩、陪聊类职位；</p>
		<p>28. 挂靠类信息；</p>
		<p>29. 部分涉及保险业务的信息；</p>
		<p>30. 兼职推⼴或为其他平台拉⽤户的信息；</p>
		<p>31. 涉及⽹络发⾏、销售彩票类信息；</p>
		<p>32. 被多位⽤户举报的信息；</p>
		<p>33. 涉及体验师类的信息（含兼职），例如旅游体验师等；</p>
		<p>34. 涉及发布超越正常⼯作范围的招工信息，或信息涉及私密关系的情况，如：陪酒、陪吃、陪住、陪玩、陪聊等；</p>
		<p>35. 涉及发布涉政、涉军等敏感及涉密内容的信息；</p>
		<p>36. 其他存在⾼⻛险及不符合产品政策的信息</p>
		<p class="head">四、禁⽌实施的⾏为</p>
		<p>本平台严禁⽤户利⽤芝麻招工平台服务，在发布、电话联系等各项环节，实施下述⾏为。如您/您的关联账号存在下述⾏为，您的招工信息（免费、付费）均有可能⽆法审核通过或被删除/屏蔽；对于造成严重后果者，会对涉事账号进行暂时或永久冻结：
		</p>
		<p>1. 违反以下“七条底线”的行为</p>
		<p>（1）法律法规底线</p>
		<p>（2）社会主义制度底线</p>
		<p>（3）国家利益底线</p>
		<p>（4）公民合法权益底线</p>
		<p>（5）社会公共秩序底线</p>
		<p>（6）道德风尚底线</p>
		<p>（7）信息真实性底线</p>
		<p>2. 存在以下“九不准”的行为</p>
		<p>（1）反对宪法所规定的基本原则的；</p>
		<p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
		<p>（3）损害国家荣誉和利益的；</p>
		<p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
		<p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
		<p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
		<p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或教唆犯罪的；</p>
		<p>（8）侮辱或诽谤他人，侵害他们合法权益的；</p>
		<p>（9）含有法律、行政法规禁止的其他内容的。</p>
		<p>3. 实施任何辱党、辱国、传播邪教思想等违法及违背公序良俗的⾏为；</p>
		<p>4. 在平台内使⽤涉及各国政治⼈物的图⽚；</p>
		<p>5. 在平台内使⽤含⾊情、淫秽内容的图⽚；</p>
		<p>6. 在平台内使⽤⼈身攻击或其他侵害他⼈权益的图⽚；</p>
		<p>7. 通过⾮芝麻招工开发、授权的第三⽅软件、插件、外挂或系统或其他不正常的⽅式，登录、使⽤芝麻招工平台服务，影响或可能影响芝麻招工平台管理运营秩序的；</p>
		<p>8. 以培训费、服装费、⼯作需要等任何名义向求职者索要财物、收取求职者费⽤、引导求职者贷款等；</p>
		<p>9. 实施传销活动或骗取他⼈加⼊传销组织的；</p>
		<p>10. 招聘他⼈从事违法违规、违背公序良俗的活动，包括但不限于代办银行账户、代办工商信息、刷单、赌博等；</p>
		<p>11. 直接或变相索取其他⽤户个⼈信息的⾏为；</p>
		<p>12. 骚扰其他⽤户，公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
		<p>13. 利⽤平台可能存在的漏洞进⾏“撸⽺⽑”、恶意获取“积分”、倒卖账号等；</p>
		<p>14. 在平台内使⽤涉及⼴告（寻求合作）、营销的头像或宣传图⽚；</p>
		<p>15. 以招聘名义招⼈培训，代办职业技能证书及其他各类证件、推广产品等行为的；</p>
		<p>16. 注册多个账号或利用其他技术手段重复或刷屏发布相同信息的；</p>
		<p>17. 招聘未满16周岁⼈员；</p>
		<p>18. 未通过平台功能与⽤户交换联系⽅式或诱导⽤户站外求职招聘，例如发送包含社交账号/通信⽅式（例如微信号/QQ号/⼿机号/第三⽅⽹站链接等）的联系信息、发布包含前述内容的职位；</p>
		<p>19.
			发表、传送、传播、使用、储存侵害他人知识产权、商业秘密、隐私权、个人信息等合法权利的内容（除非用户拥有或控制着相应的权利或已得到所有必要的认可）以及包含病毒、木马等可能对芝麻招工平台造成伤害或影响其稳定性的内容；
		</p>
		<p>20. 制造虚假身份以误导、欺骗他人；</p>
		<p>21. 招聘上有对少数民族、乙肝病毒携带者、新冠肺炎康复者等劳动者的不公平和歧视行为；</p>
		<p>22. 其他违反法律法规、违背公序良俗、对抗平台规则、破坏平台秩序等不当行为；</p>
		<p class="head">五、违规处罚规则</p>
		<p>1. 本平台有权对您发布的招工信息进⾏审核，对于不符合本规则的内容，有权采取拒绝发布、部分或全部删除等处理措施。</p>
		<p>2.
			如您违反前述第⼆条、第三条、第四条规定的内容，或者有其他可能损害芝麻招工利益或违法⾏为的，芝麻招工有权视情节采取，包括但不限于冻结您账户的⽅式暂时乃⾄永久停⽌使⽤芝麻招工平台服务且不做解封与退款处理、限制部分或全部功能的使⽤等相关处理措施。如您的⾏为涉嫌违法犯罪的，芝麻招工有权向有关⾏政机关及司法部⻔举报、披露相关信息。
		</p>
		<p>3. 您或您的关联账号涉嫌违反本规则，或者有其他明显损害本平台利益或违法⾏为的，经本平台发现或本平台⽤户投诉后核实的，芝麻招工有权视情节采取冻结账户的⽅式暂时乃⾄永久停⽌您使⽤芝麻招工服务且不做解封与退款处理。</p>
		<p>4. 如您的⾏为给芝麻招工造成损失的，芝麻招工有权要求您赔偿全部的损失；如涉嫌违法犯罪的，芝麻招工有权向有关⾏政机关及司法部⻔举报、披露相关信息。</p>
		<p>5. 如您违反本规则的情节严重的，芝麻招工公司有权冻结您的账号及其关联账号，即不再为您提供相关服务。</p>
		<p>6.
			为防⽌信息泄露，保障芝麻招工平台的稳定及安全，任何⽤户不得使⽤任何相关招聘管理系统/插件/外挂/⼯具/ATS，访问或接⼊芝麻招工系统及/或获取免费及付费服务（包括但不限于登录芝麻招工账号、发布招工、找活名片信息、浏览招工信息、找活名片等）同时，⽤户不得制作、发布、传播上述插件/外挂/⼯具，⽆论以任何目的。
		</p>
		<p>7. 如您违反本规则的，本平台可以依据本规则直接采取相关措施，并视情节严重程度选择是否通知⽤户。接到通知，您可以通过官方指定客服热线向本平台提交申诉。</p>
		<p>8. 两个或多个不同手机号注册或不同方式注册的账号，被系统判定是关联账号的，如其中⼀个账号因违法违规被冻结的，其他关联账号均将被同时冻结。</p>
		<p class="head">六、其他规则</p>
		<p>1. 本平台有权根据法律法规、政策及产品需求更新本规则，并在平台内予以公布。新的规则⾃公布之⽇起⽣效。</p>
		<p>【发布⽇期：2023年03⽉01⽇】</p>
		<p>【⽣效⽇期：2023年03⽉01⽇】</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '《芝麻招工信息发布规则协议》'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
